module.exports = __webpack_public_path__ + "img/check-mark.0ae57040.svg";